(() => {
  angular
    .module('complianceFrameworkApp.socialMediaCompliance')
    .controller('BrandMonitorFormController', BrandMonitorFormController);

  /* ngInject */
  function BrandMonitorFormController($state, $stateParams, Flash, brandMonitorService, sessionService) {
    const vm = this;

    vm.brandMonitor = {};
    vm.id = $stateParams.id;
    vm.saveBrandMonitor = saveBrandMonitor;

    activate();

    function activate() {
      if (vm.id) {
        getBrandMonitor();
      } else {
        vm.brandMonitor.owner_type = 'User';
        vm.brandMonitor.exact_match = true;
        vm.brandMonitor.status = 'Active';
      }
    }

    function getBrandMonitor() {
      brandMonitorService(sessionService.getAuthToken()).get({ id: vm.id }, response => vm.brandMonitor = response);
    }

    function saveBrandMonitor() {
      if (vm.id) {
        brandMonitorService(sessionService.getAuthToken()).update({ id: vm.id }, vm.brandMonitor,
          _ => {
            $state.go('application.social_media_compliance.brand_monitors');
            Flash.create('success', 'Brand monitor successfully updated.');
          },
          _ => {
            Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.'); 
          }
        );
      } else {
        brandMonitorService(sessionService.getAuthToken()).create(vm.brandMonitor,
        _ => {
          $state.go('application.social_media_compliance.brand_monitors');
          Flash.create('success', 'Brand monitor successfully created.');
        },
        _ => {
          Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.'); 
        });
      }
    }
  }
})();
